import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { getUserProfile } from "../../apis/authUserApi";
import { clearCacheApi } from "../../apis/clearCacheApi";
import { getAdminNotificationApi } from "../../apis/notificationApi";
import {
  loginClear,
  openNotificationDropdownMenu,
  closeNotificationDropdownMenu,
  updateToken,
} from "../../redux/reducer/authReducer";
import "./navbar.css";
import { ToastError, ToastSuccess } from "../toastify";
import { fetchAcedemicYears, fetchCities, updateTokenApi } from "../../apis/studentApi";
import { getAcedYear, reload } from "../../utils/utils";
import Loader from "../loader/Loader";
import ReactSelect from "react-select";
import { setAcedemicYear } from "../../redux/reducer/userReducer";

export default function NavBar({ setShowSidebar }) {
  const {
    user,
    profileDetails,
    openNotificationMenu,
    notificationSuccess,
    notificationLoading,
  } = useSelector((state) => state?.auth);
  const { clearCacheSuccess } = useSelector((state) => state?.clearCache);
  const { acedemicYearList } = useSelector((state) => state?.students);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { sidebarOpen, defaultAcedYr } = useSelector((state) => state.users);
  const [openMenu, setOpenMenu] = useState(false);
  const notificationDropDownRef = useRef(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageLength, setPageLength] = useState(3);
  const [showLoadMore, setShowLoadMore] = useState(false);
  const [showNoticeBoard, setShowNoticeBoard] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cityId, setCityId] = useState(user?.cityId);
  const [cityList, setCityList] = useState([]);
  const [selectCity, setSelectCity] = useState(null);

  const isNotificationDetailPage =
    location.pathname.includes("all-notifications");

  const LoadMoreButton = ({ isLoading, handleLoadMoreClick }) => {
    return (
      <div onClick={handleLoadMoreClick}>
        <button className="show_more_button_notification">
          {isLoading ? "Loading..." : "Show More"}
        </button>
      </div>
    );
  };

  const getPageNumber = ({ totalRecord, itemsPerPage }) => {
    if (!totalRecord || !itemsPerPage) return;
    return Math.ceil(totalRecord / itemsPerPage);
  };

  useEffect(() => {
    const data = {
      pageNumber: pageNumber,
      pageSize: 5,
    };
    const getAllNotificationsApi = () => {
      getAdminNotificationApi({ dispatch, data, token: user?.token });
    };
    getAcedemicYear();

    if (user?.isSuperAdmin) {
      getCity()
    }
  }, []);

  const getAcedemicYear = async () => {
    const res = await fetchAcedemicYears({ dispatch, token: user?.token })
  }
  const getCity = async () => {
    // getAllNotificationsApi(data);
    const cityRes = await fetchCities({ dispatch, payload: [0] })
    if (cityRes.statusCode === 200) {
      const transformedCities = cityRes?.data.map((city) => ({
        ...city,
        value: city.id,
        label: city.name,
      }));
      const AllCity = [...[{ id: '0', value: '0', label: 'All' }], ...transformedCities]
      // if(user?.cityId) {
      let defaultCity = AllCity.find((i) => user?.cityId == i.id);
      setSelectCity(defaultCity);
      // }
      setCityList(AllCity || [])
    }
  }

  useEffect(() => {
    if (notificationSuccess?.statusCode === 200) {
      if (
        !(
          getPageNumber({
            totalRecord: notificationSuccess?.data?.totalRecord,
            itemsPerPage: pageLength,
          }) === pageNumber
        )
      ) {
        setShowLoadMore(true);
      } else {
        setShowLoadMore(false);
      }

      if (notificationSuccess?.data) {
        if (pageNumber === 1) {
          setShowNoticeBoard(notificationSuccess?.data?.notification);
        } else {
          setShowNoticeBoard([
            ...showNoticeBoard,
            ...notificationSuccess?.data?.notification,
          ]);
        }
      } else {
        setShowNoticeBoard([]);
      }
    }
  }, [notificationSuccess]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [notificationDropDownRef]);

  const openNotificationBox = () => {
    const data = {
      pageNumber: pageNumber,
      pageSize: 3,
    };
    // getReadNotificationApi({ dispatch, token: user?.token });
    // getAdminNotificationApi({ dispatch, data, token: user?.token });
    if (openNotificationMenu) {
      dispatch(closeNotificationDropdownMenu());
    } else {
      dispatch(openNotificationDropdownMenu());
      // dispatch(closeMessageDropdownMenu());
      return;
    }
  };

  const handleClickOutside = (e) => {
    if (
      notificationDropDownRef.current &&
      !notificationDropDownRef.current.contains(e.target)
    ) {
      dispatch(closeNotificationDropdownMenu());
    }
  };

  useEffect(() => {
    fetchProfileData();
  }, [user?.token]);

  const fetchProfileData = () => {
    getUserProfile({ dispatch, token: user?.token });
  };

  const handleLogout = () => {
    localStorage.removeItem("auth-user");
    dispatch(loginClear());
    navigate("/", { replace: true });
  };

  const handleNavigate = () => {
    navigate("/edit-profile");
  };

  const handleClearCache = () => {
    clearCacheApi({ dispatch, token: user?.token });
  };

  useEffect(() => {
    if (clearCacheSuccess?.statusCode === 200) {
      ToastSuccess(clearCacheSuccess?.message);
    }

    if (clearCacheSuccess?.statusCode === 400) {
      ToastError(clearCacheSuccess?.message);
    }
  }, [clearCacheSuccess]);

  const handleLoadMoreClick = (e) => {
    e.stopPropagation();
    navigate(`/all-notifications`);
    dispatch(closeNotificationDropdownMenu());
  };

  const handleSelectCity = async (selectedCity) => {
    setSelectCity(selectedCity);
    setLoading(true)
    setCityId(selectedCity.value)
    let res = await updateTokenApi({ dispatch, token: user?.token, data: { cityId: selectedCity.value } });
    if (res?.statusCode === 200) {
      setLoading(false)
      dispatch(updateToken({ token: res?.data?.token, cityId: selectedCity.value }));
      reload()
    }
    if (res?.statusCode === 400) {
      setLoading(false)
      ToastError(res.data?.message);
    }
  }

  const handleYear = (e) => {
    dispatch(setAcedemicYear(e.target.value));

  }
  return (
    <nav
      className={`${!sidebarOpen ? "main-header" : null
        } navbar navbar-expand navbar-white navbar-light`}
    >
      {loading && <Loader />}

      <ul className="navbar-nav mb-3">
        <li className="nav-item" onClick={setShowSidebar}>
          <a className="nav-link" data-widget="control-sidebar" href="#" role="button">
            <i className="fas fa-bars"></i>
          </a>
        </li>
      </ul>

      <ul className="navbar-nav ml-auto">
        {/* {!isNotificationDetailPage && (
          <li className="notification_box" onClick={openNotificationBox}>
            <i className="icon-notifications"></i>
            <div className="dot"></div>
            {openNotificationMenu ? (
              <div
                className="notification_list_container"
                ref={notificationDropDownRef}
              >
                <div className="chevron"></div>
                <div className="notification_list">
                  {notificationSuccess?.data?.notification?.length > 0 ? (
                    notificationSuccess?.data?.notification
                      .slice(0, 3)
                      ?.map((data) => (
                        <div className="notification_detail" key={data.id}>
                          <div className="detail">
                            <h6>{data?.title}</h6>
                            <p
                              className="message_data_1"
                              dangerouslySetInnerHTML={{ __html: data?.body }}
                            ></p>
                            <p className="message_date">{data?.date}</p>
                          </div>
                        </div>
                      ))
                  ) : (
                    <div className="notification_detail">
                      <div className="detail">
                        <p className="date">You don't have any notification</p>
                      </div>
                    </div>
                  )}

                  {notificationSuccess?.data?.totalRecord >
                  showNoticeBoard.length ? (
                    <LoadMoreButton
                      handleLoadMoreClick={handleLoadMoreClick}
                      isLoading={notificationLoading}
                    />
                  ) : null}
                </div>
              </div>
            ) : null}
          </li>
        )} */}
        {user?.isSuperAdmin && <li>
          <div className="form-group " style={{ width: '100%', minWidth: '100px' }}>
            {/* <label htmlFor="cityId">City</label><sup className="text-danger">* </sup> */}
            <div className="input_box">
              {/* <select
              className="form-control"
              id="cityId"
              name="cityId"
              onChange={(e) => handleChange(e)}
              value={cityId}
            >
              <option value="0">All</option>
              {cityList?.map((item) => (
                <option key={item.id} value={item.id}>{item.name}</option>
              ))}
            </select> */}
              <ReactSelect
                options={cityList}
                name="cityId"
                id="cityId"
                value={selectCity}
                onChange={handleSelectCity}
                className="basic-multi-select"
                classNamePrefix="City"
              ></ReactSelect>
            </div>
          </div>
        </li>}
        <li>
          <div className="form-group " style={{ width: '100%' }}>
            <div className="input_box">
              <select
                className="form-control"
                id="defaultAcedYr"
                name="defaultAcedYr"
                onChange={(e) => handleYear(e)}
                value={defaultAcedYr || getAcedYear() || 0}
              >
                <option value="0">Select Acedemic Year</option>
                {acedemicYearList?.map((val) => ({ ...val, id: val?.year }))?.map((item) => (
                  <option key={item.id} value={item.year}>{item.title}</option>
                ))}
              </select>
            </div>
          </div>
        </li>
        <li>
          <div className="profile_box" onClick={() => setOpenMenu(!openMenu)}>
            <div
              className="profile_image"
              style={{ backgroundImage: `url(${profileDetails?.profileUrl || 'https://icones.pro/wp-content/uploads/2021/03/avatar-de-personne-icone-homme.png'})` }}
            ></div>
            <p>{profileDetails?.name}</p>
            {openMenu && (
              <div className="profile_menu">
                <div className="chevron"></div>
                <div className="edit_profile_box">
                  <div className="profile_edit">
                    <div
                      className="profile_image"
                      style={{
                        backgroundImage: `url(${profileDetails?.profileUrl || 'https://icones.pro/wp-content/uploads/2021/03/avatar-de-personne-icone-homme.png'})`,
                      }}
                    ></div>
                    <div className="detail">
                      <h6>{profileDetails?.name}</h6>
                      <p>{profileDetails?.email}</p>
                    </div>
                  </div>
                  <div className="edit_icon_box" onClick={handleNavigate}>
                    <i className="icon-edit"></i>
                  </div>
                </div>
                {/* <div
                  className="menu_link"
                  onClick={() => navigate("/user-support")}
                >
                  <span>Support</span>
                </div> */}
                <div className="menu_link" onClick={handleClearCache}>
                  <span>Clear Cache</span>
                </div>
                <div className="menu_link" onClick={handleLogout}>
                  <i className="icon-logout"></i>
                  <span>Logout</span>
                </div>
              </div>
            )}
          </div>
        </li>
      </ul>
    </nav>
  );
}
